import cameraIcon from "../assets/images/icons/camera.svg";
import SalonActivityLayout from "../components/SalonActivityLayout";
import { useTranslation } from "../components/Localization";

export default function SalonVideoTaskPage() {
  const { t } = useTranslation();
  return <SalonActivityLayout taskKey="video" step={3} gesture="up" progressIcon="top-right" backTo="/szalon/radio" nextTo="/szalon/eredmeny">
    <button className="salon-video" aria-label={t("accessibility.videoPlayback")}><img src={cameraIcon} alt="" /></button>
  </SalonActivityLayout>;
}
